import { render, staticRenderFns } from "./ErrorNotes.vue?vue&type=template&id=2cbc721e&scoped=true"
import script from "./ErrorNotes.vue?vue&type=script&lang=js"
export * from "./ErrorNotes.vue?vue&type=script&lang=js"
import style0 from "./ErrorNotes.vue?vue&type=style&index=0&id=2cbc721e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc721e",
  null
  
)

export default component.exports